import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Grid} from '@mui/material';
import {FormBuilder} from '../../../../../form/FormBuilder';
import {onRejectSubmit} from '../../../../../form/errorHandler';
import schema from './schema/field_value.json';
import {FormSchema} from '../../../../../form/logic/FormSchema';
import {FormState} from '../../../../../form/state/FormState';
import {useNotifications} from '../../hooks/useNodifications';
import {FormFieldValue} from '../../model/FormFieldValue';
import {useFieldValuesContext} from '../../contexts/FieldValuesContext';

interface Props {
  partial: Partial<FormFieldValue>;
}

export default function FieldValueEditorCreate({partial}: Props) {
  const {t} = useTranslation();
  const {sendSuccess} = useNotifications();
  const {handleCreate, locked} = useFieldValuesContext();

  function onSubmit(formData: any, state: FormState) {
    handleCreate(formData).then(() => sendSuccess(`FieldValue created`));
  }

  return (
    <Grid container spacing={3} rowSpacing={3}>
      <Grid item xs={12}>
        <FormBuilder
          onRejectSubmit={onRejectSubmit}
          formSchema={schema as FormSchema}
          initialValues={partial}
          onSubmit={onSubmit}
        >
          <Button disabled={locked} type={'submit'}>
            {t('shared.save')}
          </Button>
        </FormBuilder>
      </Grid>
    </Grid>
  );
}
